import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import hydroponics_systems_dutch_bucket2 from "../../Assets/hydroponics_systems_dutch_bucket2.webp";
import hydroponics_systems_dutch_bucket3 from "../../Assets/hydroponics_systems_dutch_bucket3.webp";
import hydroponics_systems_dutch_bucket4 from "../../Assets/hydroponics_systems_dutch_bucket4.webp";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tab, Nav, Carousel } from "react-bootstrap";
import "../../App.css";

const Dutch_bucket_shop = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 60,
      name: "Twisted Rope (Tensioning Rope)",
      price: 250,
      image: hydroponics_systems_dutch_bucket2,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-md-6">
          <Carousel>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={hydroponics_systems_dutch_bucket2}
                alt="Twisted Rope 1"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={hydroponics_systems_dutch_bucket3}
                alt="Twisted Rope 2"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={hydroponics_systems_dutch_bucket4}
                alt="Twisted Rope 3"
              />
            </Carousel.Item>
          </Carousel>
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">Dutch Bucket System</h2>
            <p className="product-price">
              <a href="/Contact" className="btn btn-link">
                Contact Us for Price Details
              </a>
            </p>

            {/* <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button> */}

            <div className="row mt-4">
              <div className="col-12">
                <p className="text-justify">
                  The Dutch Bucket System (also known as the Bato Bucket System)
                  is a highly efficient and versatile hydroponic growing system
                  ideal for cultivating vine crops such as tomatoes, cucumbers,
                  peppers, and eggplants. Each bucket operates as an individual
                  growing unit, allowing for precise control of nutrients and
                  water.
                </p>
                <i>Note: Minimum Order Quantity: 10 Units</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Section with Border */}
      <div className="row mt-4">
        <div className="col-12 border-tabs">
          <Tab.Container defaultActiveKey="Specifications">
            <Nav variant="tabs" className="mb-3 custom-nav">
              <Nav.Item>
                <Nav.Link eventKey="Specifications" className="custom-tab">
                  Product Specifications
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Features" className="custom-tab">
                  Features
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="moreInfo" className="custom-tab">
                  Additional Information
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="Specifications">
                <ul>
                  <li>
                    <span className="fw-bold">Material:</span> High-quality
                    UV-stabilized plastic
                  </li>
                  <li>
                    <span className="fw-bold">Capacity:</span> 11–15 liters per
                    bucket
                  </li>
                  <li>
                    <span className="fw-bold">Color:</span> Typically black or
                    white to support root health
                  </li>
                  <li>
                    <span className="fw-bold">Drainage System:</span> Siphon
                    elbows included for efficient water drainage and
                    recirculation
                  </li>
                  <li>
                    <span className="fw-bold">Dimensions:</span>Custom sizes
                    available
                  </li>
                  <li>
                    <span className="fw-bold">Mounting:</span> Can be installed
                    on flatbed or A-frame structures
                  </li>
                  <li>
                    <span className="fw-bold">Brand:</span> RGCPL
                  </li>
                  <li>
                    <span className="fw-bold">Minimum Order Quantity:</span> 10
                    buckets
                  </li>
                  <li>
                    <span className="fw-bold">Durability:</span> 5+ Years with
                    proper care
                  </li>
                </ul>
              </Tab.Pane>

              <Tab.Pane eventKey="Features">
                <h4>Features</h4>
                <ul>
                  <li>
                    Scalable: Easily expandable for small- or large-scale
                    operations
                  </li>
                  <li>
                    Efficient Water Use: Supports both drain-to-waste and
                    recirculating systems
                  </li>
                  <li>
                    Clean Root Zone: Promotes healthier roots by maintaining
                    good drainage
                  </li>
                  <li>
                    Modular Design: Easy to move, clean, and manage each plant
                    individually
                  </li>
                  <li>
                    Strong Build: Durable for long-term use in various climates
                  </li>
                </ul>
              </Tab.Pane>

              <Tab.Pane eventKey="moreInfo">
                <h4>Additional Information</h4>
                <ul>
                  <li>
                    <span className="fw-bold">Item Code:</span> RGCPL-0036
                  </li>
                  <li>
                    <span className="fw-bold">Delivery Time:</span> 7-8 Days
                  </li>
                  <li>
                    <span className="fw-bold">Port of Dispatch:</span>{" "}
                    Maharashtra, India
                  </li>
                  <li>
                    <span className="fw-bold">Production Capacity:</span> 500
                    Buckets Per Day
                  </li>
                  <li>
                    <span className="fw-bold">Packaging Details:</span>{" "}
                    Corrugated boxes or as per client request
                  </li>
                  <li>
                    <span className="fw-bold">Payment Terms:</span> Advance
                    Payment
                  </li>
                  <li>
                    <span className="fw-bold">Payment Mode:</span> RTGS / NEFT /
                    IMPS
                  </li>
                </ul>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>

        <h5 className="mt-3">Importance of Dutch Bucket System:</h5>
        <p className="text-justify">
          Dutch Bucket Systems provide a sustainable and controlled method to
          grow high-yield crops in limited space, making them perfect for both
          commercial greenhouses and urban farms.
        </p>

        <h5 className="mt-3">Key Benefits of Dutch Bucket System:</h5>
        <ul>
          <li>Ideal for growing heavy-feeding and fruiting plants.</li>
          <li>Reduces water and nutrient wastage through recirculation.</li>
          <li>Promotes uniform growth with consistent root zone conditions.</li>
          <li>Easy to maintain and scale</li>
        </ul>

        <h5 className="mt-3">Applications of Dutch Bucket System:</h5>
        <ul>
          <li>Commercial hydroponic farms growing vine crops.</li>
          <li>Urban rooftop or indoor gardening systems.</li>
          <li>Greenhouses needing modular plant support</li>
          <li>Research setups for controlled environment agriculture</li>
        </ul>
      </div>

      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Dutch_bucket_shop;
